export function getWeatherIcon(weatherMain: string): string {
    switch (weatherMain.toLowerCase()) {
      case "clear":
        return "wb_sunny";
      case "clouds":
        return "wb_cloudy";
      case "rain":
      case "drizzle":
        return "rainy"; // Falls "rainy" nicht verfügbar ist, könntest du "umbrella" nutzen
      case "thunderstorm":
        return "flash_on";
      case "snow":
        return "ac_unit";
      case "mist":
      case "smoke":
      case "haze":
      case "dust":
      case "fog":
      case "sand":
      case "ash":
        return "dehaze";
      case "squall":
      case "tornado":
        return "wind_power";
      default:
        return "wb_sunny";
    }
  }
  